import { idtype } from "querypieces";

export default `
  ...on articleBuilder_pullquote_BlockType {
    ${idtype}
    statement
    attribution
  }
`;
